import React from 'react'
import {
  AdminNotificationType,
  AdminNotificationTypeCount,
} from '../../types/admin-notification.type'
import {NOTIFICATION_TYPE_LABELS} from './notification-links'

type Props = {
  unreadCount: number
  countsByType: AdminNotificationTypeCount[]
  compact?: boolean
  onMarkAllAsRead: () => void
  onRefresh: () => void
}

const typeLabel = (type: string): string =>
  NOTIFICATION_TYPE_LABELS[type as AdminNotificationType] ?? type

/** Shown when the badge says unread exist but the list query returned nothing. */
export const GhostUnreadEmpty: React.FC<Props> = ({
  unreadCount,
  countsByType,
  compact,
  onMarkAllAsRead,
  onRefresh,
}) => {
  const rows = (countsByType ?? []).filter((row) => (row.count ?? 0) > 0)

  return (
    <div className={compact ? 'px-6 py-8 text-center' : 'text-center py-12 px-6'}>
      <div className={`fw-semibold text-gray-800 ${compact ? 'fs-7' : 'fs-5'} mb-2`}>
        {unreadCount} unread on the server but none loaded
      </div>
      <div className={`text-muted ${compact ? 'fs-8' : 'fs-7'} mb-4`}>
        The badge and inbox disagree — often stuck read receipts or a failed list load. Mark all
        read to clear the badge, or refresh to retry.
      </div>

      {rows.length > 0 ? (
        <div
          className={`d-flex flex-wrap justify-content-center gap-2 mb-5 ${
            compact ? 'fs-9' : 'fs-8'
          }`}
        >
          {rows.map((row) => (
            <span key={row.type} className='badge badge-light-danger'>
              {typeLabel(row.type)}: {row.count}
            </span>
          ))}
        </div>
      ) : null}

      <div className='d-flex flex-wrap justify-content-center gap-2'>
        <button
          type='button'
          className={`btn btn-light-primary ${compact ? 'btn-sm py-1 px-3 fs-8' : 'btn-sm'}`}
          onClick={onMarkAllAsRead}
        >
          Mark all as read
        </button>
        <button
          type='button'
          className={`btn btn-light ${compact ? 'btn-sm py-1 px-3 fs-8' : 'btn-sm'}`}
          onClick={onRefresh}
        >
          Refresh
        </button>
      </div>
    </div>
  )
}

export default GhostUnreadEmpty
